import { useState, useEffect } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter,
} from "@/components/ui/dialog";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export const EventDialog = ({ open, onOpenChange, onSave, event }) => {
  const [name, setName] = useState("");
  const [destType, setDestType] = useState("whatsapp");
  const [message, setMessage] = useState("");
  const [url, setUrl] = useState("");
  const isEdit = !!event;

  useEffect(() => {
    if (open) {
      setName(event?.name || "");
      setDestType(event?.dest_type || "whatsapp");
      setMessage(event?.message || "");
      setUrl(event?.url || "");
    }
  }, [open, event]);

  const save = () => {
    if (!name.trim()) return;
    if (destType === "whatsapp" && !message.trim()) return;
    if (destType === "url" && !url.trim()) return;
    onSave({
      name: name.trim(),
      dest_type: destType,
      message: destType === "whatsapp" ? message.trim() : "",
      url: destType === "url" ? url.trim() : null,
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="event-dialog" className="rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-extrabold tracking-tighter">
            {isEdit ? "Edit Event" : "New Event"}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="ev-name">Event name</Label>
            <Input id="ev-name" data-testid="event-name-input" placeholder="e.g. Trade Expo, Weekly Meetup"
              value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="space-y-2">
            <Label>When scanned, this event opens</Label>
            <Select value={destType} onValueChange={setDestType}>
              <SelectTrigger data-testid="event-dest-select"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="whatsapp" data-testid="dest-whatsapp">WhatsApp message</SelectItem>
                <SelectItem value="url" data-testid="dest-url">A link / website URL</SelectItem>
              </SelectContent>
            </Select>
          </div>
          {destType === "whatsapp" ? (
            <div className="space-y-2">
              <Label htmlFor="ev-msg">WhatsApp message</Label>
              <Textarea id="ev-msg" data-testid="event-message-input" rows={5}
                placeholder="Hi! Great meeting you at the event..." value={message}
                onChange={(e) => setMessage(e.target.value)} />
              <p className="text-xs text-muted-foreground">Pre-filled in WhatsApp (to your saved number) when scanned.</p>
            </div>
          ) : (
            <div className="space-y-2">
              <Label htmlFor="ev-url">Destination URL</Label>
              <Input id="ev-url" data-testid="event-url-input" placeholder="https://your-website.com"
                value={url} onChange={(e) => setUrl(e.target.value)} />
              <p className="text-xs text-muted-foreground">Scanning opens this link directly.</p>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={() => onOpenChange(false)} data-testid="event-cancel-btn">Cancel</Button>
          <Button className="rounded-full active:scale-95 transition-transform duration-150" onClick={save} data-testid="event-save-btn">
            {isEdit ? "Save changes" : "Create event"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
